import { enableCanaryToken } from '@gonfalon/dogfood-flags/dogfood-flags';

import { loadCanaryToken } from './loadCanaryToken';

export const initCanaryToken = () => {
  if (enableCanaryToken()) {
    loadCanaryToken();
  }
};
